/**
 * Human-friendly Italian labels for the AI agent tools. Single source shared by
 * the Agents admin page and the Playground so a new tool only needs one entry.
 * Falls back to the raw tool name when no label is defined.
 */
export const TOOL_LABELS = {
  searchProducts: 'Ricerca prodotti',
  getInventory: 'Disponibilità e scorte',
  searchKnowledge: 'Knowledge base (RAG)',
  getStoreInfo: 'Informazioni negozio',
  compareProducts: 'Confronto prodotti',
  getCustomerProfile: 'Profilo cliente',
  compareFormulations: 'Confronto formulazioni',
  findAlternatives: 'Alternative prodotto',
  plateBreakdown: 'Piatto ORME',
  getOrmeLevelGuidance: 'Livello ORME (CNO)',
  getProductDatasheet: 'Scheda prodotto',
  recommendEducationalContent: 'Contenuti educativi',
  suggestConsultationQuestions: 'Domande consulenza',
  requestKioskLogin: 'Accesso cliente (QR)',
  proposeRegistration: 'Registrazione cliente',
  getMyProfile: 'Il mio profilo (portale)',
  getMyAnimals: 'I miei animali (portale)',
  getMyPetDiary: 'Diario del mio animale (portale)',
  getMyPetPlate: 'Piatto del mio animale (portale)'
};

export function toolLabel(name) {
  return TOOL_LABELS[name] || name;
}
